import React from 'react';
import { Relative } from 'global/StreamCompose/ImageContainer/styled';
import {
  ImageContainer,
  ImageUpload,
  IconCloseWrapper,
  IconClose,
} from './styled';

type imageDimensionsProps = {
  width?: number;
  height?: number;
}

interface ImageItemProps {
  image?: string;
  imageDimensions?: imageDimensionsProps;
  onDelete?: () => any;
}

function ImageItem({
  image: imageSrc,
  imageDimensions,
  onDelete,
}: ImageItemProps) {
  if (!imageSrc) {
    return <div />;
  }

  let longImage = false;
  if (imageDimensions) {
    const { width, height } = imageDimensions;
    if (width && height) {
      // if image ratio from input more than 16/9 set longImage to true
      // it will adjust default style
      longImage = (width / height) > 1.77;
    }
  }

  return (
    <Relative>
      <IconCloseWrapper onClick={onDelete}>
        <IconClose className="icon-compose_close" />
      </IconCloseWrapper>
      <ImageContainer>
        <ImageUpload alt="uploader" src={imageSrc} isLongImage={longImage} />
      </ImageContainer>
    </Relative>
  );
}

export default React.memo(ImageItem);
